export const ACTIVATE_SOURCE = 'ACTIVATE_SOURCE';
export const PAUSE_SOURCE = 'PAUSE_SOURCE';
export const RUN_SOURCE_NOW = 'RUN_SOURCE_NOW';
export const COPY_SOURCE = 'COPY_SOURCE';
export const DELETE_SOURCE = 'DELETE_SOURCE';
export const UPLOAD_FILE = 'UPLOAD_FILE';
export const ACTIVATE_DATA_SET = 'ACTIVATE_DATA_SET';
export const PAUSE_DATA_SET = 'PAUSE_DATA_SET';
export const COPY_DATA_SET = 'COPY_DATA_SET';
export const DELETE_DATA_SET = 'DELETE_DATA_SET';
export const COPY_DATA_SET_TO_CLIPBOARD_INFO = 'COPY_DATA_SET_TO_CLIPBOARD_INFO';
export const PASTE_DATA_SET_TRANSFORM = 'PASTE_DATA_SET_TRANSFORM';
export const PASTE_DATA_SET_TRANSFORM_INFO = 'PASTE_DATA_SET_TRANSFORM_INFO';
export const ACTIVATE_SINK = 'ACTIVATE_SINK';
export const PAUSE_SINK = 'PAUSE_SINK';
export const COPY_SINK = 'COPY_SINK';
export const DELETE_SINK = 'DELETE_SINK';
export const REGISTER_DATASET_ON_CATALOG = 'REGISTER_DATASET_ON_CATALOG';
export const DELETE_PROJECT = 'DELETE_PROJECT';
export const CREATE_PROJECT = 'CREATE_PROJECT';
// Api Key
export const PAUSE_API_KEY = 'PAUSE_API_KEY';
export const ACTIVATE_API_KEY = 'ACTIVATE_API_KEY';
export const ROTATE_API_KEY = 'ROTATE_API_KEY';
export const DELETE_API_KEY = 'DELETE_API_KEY';
// Service Key
export const PAUSE_SERVICE_KEY = 'PAUSE_SERVICE_KEY';
export const ACTIVATE_SERVICE_KEY = 'ACTIVATE_SERVICE_KEY';
export const ROTATE_SERVICE_KEY = 'ROTATE_SERVICE_KEY';
export const DELETE_SERVICE_KEY = 'DELETE_SERVICE_KEY';
// SDK Applications
export const DELETE_SDK_APPLICATION = 'DELETE_SDK_APPLICATION';
export const PAUSE_SDK_APPLICATION = 'PAUSE_SDK_APPLICATION';
export const ACTIVATE_SDK_APPLICATION = 'ACTIVATE_SDK_APPLICATION';
